export enum FEEDBACK_CAMPAIGN_TYPES {
  POPUP = 'POPUP',
  DIALOG = 'DIALOG',
  CARD = 'CARD',
  BANNER = 'BANNER',
}

export enum FEEDBACK_CAMPAIGN_ORIGINS {
  TYPEFORM = 'TYPEFORM',
  INTERNAL = 'INTERNAL',
}

export enum FEEDBACK_CAMPAIGN_DISPLAY_LOCATION {
  METEO = 'METEO',
  SUGGESTIONS = 'SUGGESTIONS',
  FEEDBACK = 'FEEDBACK',
  CREATE_FLASHCARDS_DECK = 'CREATE_FLASHCARDS_DECK',
  MOOD_TRACKER = 'MOOD_TRACKER',
  LESSON_EXERCISE = 'LESSON_EXERCISE',
  EXAM_REGISTRATION = 'EXAM_REGISTRATION',
}

export enum FEEDBACK_CAMPAIGN_TRIGGER_TYPES {
  AUTO = 'AUTO',
  CLICK = 'CLICK',
}

/** Ratings stored for a yes/no internal campaign answer (e.g. exam registration). */
export enum FEEDBACK_CAMPAIGN_YES_NO_RATINGS {
  NO = 0,
  YES = 1,
}

export const FEEDBACK_CAMPAIGN_ANSWER_COMMENT_MAX_LENGTH = 500;
export * from './model';
